import React from 'react'
import './annualreport.scss'
import { images } from "../../../utils/customFn";
import { Link, NavLink } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
const AnnualReport = () => {

  return (
    <>
      <div className='left-media-team'>
        <div className='top-heading-note'>
          <h2>A message from Pete</h2>
          <p>Throughout our history, our strategic business decisions helped pave the way to our success. It’s an approach we call “Sentry Smart.”</p>
          <p>In 2023, that meant adding new offices to better serve our customers, finding innovative solutions to industry challenges, investing in students, and giving back to the communities we call home.</p>
          <p>Thank you to our customers, who placed their trust in us. And thank you to our employees and retirees, whose hard work and dedication made Sentry what it is today.</p>
        </div>
      </div>
    </>
  )
}

export default AnnualReport